import styled from 'styled-components'

export const VehicleModalContainer = styled.div`
  min-height: 200px;
  position: relative;
`

export const VehicleModalInfo = styled.div`
  margin-bottom: 20px;
`

export const VehicleModalInfoItem = styled.div`
  font-size: 16px;
`

export const VehicleModalActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
`

export const RouteSheetsStatistics = styled.div`
  .ant-card-body {
    display: flex;
    gap: 12px;
    width: 100%;
    flex-wrap: wrap;
    padding: 12px;
  }

  .ant-statistic {
    flex: 1;
  }

  .ant-statistic-title {
    white-space: nowrap;
  }

  .ant-statistic-content {
    font-size: 20px;
  }
`
